const _isNull = (val, fallback) =>
  val === null || val === undefined ? fallback : val
/**
 * Global class, do not import directly from .js file, its already declared globally with window api, use it via window api instead of import from
 */
export class GoogleAnalytics {
  _sendTo = null
  _gtag = () => {}
  _route = {}

  constructor(googleId = null, gtag) {
    this._gtag = gtag
    this._sendTo = googleId
  }

  setRoute(route = {}) {
    this._route = route
  }

  getGoogleAnalyticsId() {
    return this._sendTo
  }

  getRouteOptions() {
    const { path = '', name = '', params: { lang = '' } = {} } = this._route
    const splitPath = path.split('/').splice(2, path.length)

    const pathContainsId =
      Number.isNaN(parseInt(splitPath[splitPath.length - 1])) === false

    if (pathContainsId) {
      splitPath.pop()
    }

    return [splitPath.join('/'), name, lang]
  }

  /**
   * By default it fills the fields, `pageTitle, pagePath`.
   */
  pageVisitEvent({ pageTitle = null, pagePath = null } = {}) {
    const [path, name, lang] = this.getRouteOptions()

    this._gtag('event', 'page_view', {
      page_title: _isNull(pageTitle, name),
      page_path: _isNull(pagePath, path),
      page_lang: lang,
      // send_to: this._sendTo,
    })
  }

  /**
   * Default values are:
   *
   * eventName = 'click',
   *
   * pageTitle = null, // current page  name
   *
   * pagePath = null, // current page  path
   *
   * eventName = 'generic',
   *
   * eventDescription = 'generic',
   *
   * By default it fills the fields, `pageTitle, pagePath`.
   */
  actionEvent({
    eventName = 'click',
    pageTitle = null,
    pagePath = null,
    // eventName = 'generic',
    eventDescription = 'generic',
  } = {}) {
    if (this._sendTo === null) return
    const [path, name, lang] = this.getRouteOptions()

    this._gtag('event', eventName, {
      page_title: _isNull(pageTitle, name),
      page_path: _isNull(pagePath, path),
      page_lang: lang,
      event_description: eventDescription,
      // event_name: eventName,
      // send_to: this._sendTo,
    })
  }
}
